var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"block-information",attrs:{"to":_vm.href}},[_c('div',{staticClass:"block-information__wrapper"},[_c('div',{staticClass:"block-information__bg",style:({
        background:
          'url(' +
          require(("../../assets/img/backrounds/" + _vm.source)) +
          ') center center/cover no-repeat',
      })},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"block-information__descr"},[_vm._v(_vm._s(_vm.description))]),_c('div',{staticClass:"block-information__btn"},[_vm._v(_vm._s(_vm.btntext))])])])}
var staticRenderFns = []

export { render, staticRenderFns }